export const cilLinkAlt = ["24 24","<path d='M2.25 12c0.002-2.070 1.68-3.748 3.75-3.75h5.25v-1.5h-5.25c-2.899 0-5.25 2.351-5.25 5.25s2.351 5.25 5.25 5.25v0h5.25v-1.5h-5.25c-2.070-0.002-3.748-1.68-3.75-3.75v-0z'></path><path d='M18 6.75h-5.25v1.5h5.25c2.071 0 3.75 1.679 3.75 3.75s-1.679 3.75-3.75 3.75v0h-5.25v1.5h5.25c2.899 0 5.25-2.351 5.25-5.25s-2.351-5.25-5.25-5.25v0z'></path><path d='M6.563 11.281h10.875v1.5h-10.875v-1.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-link-alt.js
// module id = null
// module chunks = 